export enum EPermissionTargets {
  LOCKER = 'LockerInterface',
  LOCKER_STATUS = 'LockerStatusInterface',
  CHANNEL = 'ChannelInterface',
  SERVICE_PROVIDER = 'ServiceProviderInterface',
  USER_PERMISSION = 'UserPermissionInterface',
  COMMUNITY = 'CommunityInterface',
}
